const links = document.querySelectorAll('.home_our_activities .menu-item a')
const contents = document.querySelectorAll('.home_our_activities .visuel_text')

let i = 0

// remove / add classes
const switchClass = (i) => {
  const itemActive = document.querySelector('.home_our_activities .menu-item a.active')
  const visuelShow = document.querySelector('.home_our_activities .visuel_text.show')

  if (itemActive && visuelShow) {
    document.querySelector('.home_our_activities .menu-item a.active').classList.remove('active')
    document.querySelector('.home_our_activities .visuel_text.show').classList.remove('show')
  }

  if (links.length && contents.length) {
    links[i].classList.add('active')
    contents[i].classList.add('show')
  }
}

// increment i to swtich between views
const SlideInterval = setInterval(() => {
  i++
  if (i > contents.length - 1) {
    i = 0
  }
  switchClass(i)
}, 3000)

// core logics to start increment i and click event
export const activitiesCarousel = () => {
  if (links.length && contents.length) {
    links[i].classList.add('active')
    contents[i].classList.add('show')

    links.forEach((link, index) => {
      link.addEventListener('click', () => {
        // console.log('click')
        i = index
        switchClass(i)
        clearInterval(SlideInterval)
      })
    })
  }
}
